module.exports = __webpack_public_path__ + "images/banners/smama_banner_sp_ebcb82a8d971c65264c10f4276c3df63.jpg";